import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { memo } from "react";
import { useSelector } from "react-redux";
import { centralizedClipIsPDFTypeSelector } from "~/store/centralizedClip/selectors";
const VERSIONS_CLASS_NAMES = "box-border flex h-[216px] w-full flex-col items-start justify-start px-6 pt-4";
export const VersionList = /*#__PURE__*/ memo((param)=>{
    let { isOpen, children } = param;
    const isPDF = useSelector(centralizedClipIsPDFTypeSelector);
    return /*#__PURE__*/ _jsx("div", {
        className: classNames("flex w-full flex-1 border-t border-t-grey-5 bg-grey-2", {
            isOpen
        }),
        children: isPDF ? isOpen && /*#__PURE__*/ _jsx("div", {
            className: VERSIONS_CLASS_NAMES,
            children: children
        }) : /*#__PURE__*/ _jsx("div", {
            className: classNames("transition-opacity delay-150", VERSIONS_CLASS_NAMES, isOpen ? "opacity-100" : "opacity-0"),
            children: children
        })
    });
});
VersionList.displayName = "VersionList";
